import enLanguage from './languages/en-GB';
//Lists
import loanPurposeList_LIMITED_COMPANY from './lists/loanPurpose_LIMITED_COMPANY';
import loanPurposeList_SOLE_TRADER from './lists/loanPurpose_SOLE_TRADER';
import propertyStatusList from './lists/propertyStatus';
import tradingActivityList from './lists/tradingActivity';
import typeOfBusiness from './lists/typeOfBusiness';
import materialTheme from './materialTheme';
import theme from './theme';

/*
 * validatorjs docs - https://github.com/skaterdav85/validatorjs
 * Cleave.js - https://github.com/nosir/cleave.js/blob/master/doc/options.md
 * moment durations - https://momentjs.com/docs/#/durations/
 * */

const locals = {
  currencySign: '£',
  country: 'UK',
  countryCode: 'GB',
  currency: 'GBP', // https://www.currency-iso.org/dam/downloads/lists/list_one.xml
  phoneMask: '... ... ....',
  useCustomCurrencyFormat: false,
  businessDays: [1, 2, 3, 4, 5],
  addressSeparator: ', ',
  numeral: true,
  numeralPositiveOnly: true,
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  numeralIntegerScale: 15,
  numeralDecimalScale: 2,
  numeralDecimalMark: '.',
  delimiter: ',',
  addressFieldsFormattersOptions: {
    name: {
      formatter: 'capitalize',
      isNextLine: false,
    },
    line1: {
      formatter: 'capitalize',
      isNextLine: false,
    },
    line2: {
      formatter: 'capitalize',
      isNextLine: false,
    },
    line3: {
      formatter: 'capitalize',
      isNextLine: false,
    },
    region: {
      formatter: 'capitalize',
      isNextLine: false,
    },
    town: {
      formatter: 'capitalize',
      isNextLine: false,
    },
    state: {
      formatter: 'capitalize',
      isNextLine: false,
    },
    country: {
      formatter: 'upperCase',
      isNextLine: false,
    },
    pobox: {
      formatter: 'capitalize',
      isNextLine: false,
    },
    postcode: {
      formatter: 'upperCase',
      isNextLine: false,
    },
  },
};

const currencyFormattingOptions = {
  type: 'number',
  numeral: locals.numeral,
  numeralPositiveOnly: locals.numeralPositiveOnly,
  maximumFractionDigits: locals.maximumFractionDigits,
  minimumFractionDigits: locals.minimumFractionDigits,
  numeralIntegerScale: locals.numeralIntegerScale,
  numeralDecimalScale: locals.numeralDecimalScale,
  numeralDecimalMark: locals.numeralDecimalMark,
  delimiter: locals.delimiter,
};

export default {
  tenantData: {
    tenantName: 'BeBank',
    tenantFullName: 'BeBank LTD.',
    useTenantBranding: true,
    theme,
    materialTheme,
    assets: {
      logo: {
        src: 'https://code.ezbob.com/app-ezx/resources/svg/BeBank_logo.svg',
        alt: 'BeBank logo',
      },
      icon: {
        src: 'https://code.ezbob.com/app-ezx/resources/svg/BeBank_icon.svg',
        alt: 'BeBank icon',
      },
      favicon: {
        src: 'https://code.ezbob.com/app-ezx/resources/svg/BeBank_icon.svg',
        alt: 'BeBank',
        alertCount: null,
        animated: true,
        animationDelay: 500,
      },
    },
  },
  system: {
    allowInactiveCases: false,
    enableDeviceFraudCheck: true,
    vendorName: 'Be Bank',
    uiVersion: `1.0.0`,
    inactiveLogout: { minutes: 10 }, // Use moment docs for formatting -  https://momentjs.com/docs/#/durations/
    checkFraud: false,
    requireLogin: false,
    disableNewCases: false,
    allowSignup: true,
    providers: { openBanking: 'accountScore' },
  },
  externalServices: {
    datadog: { enabled: false, options: {} },
    googleAnalytics: {
      events: {
        view: ['Step_didMount', 'Page_didMount'],
        interaction: ['change', 'click', 'blur'],
      },
    },
    facebookPixel: {
      events: {
        view: ['Step_didMount', 'Page_didMount'],
        interaction: [
          {
            type: 'change',
          },
          {
            type: 'click',
          },
          {
            type: 'blur',
          },
          {
            type: 'START_RECORDING',
          },
          {
            type: 'STOP_RECORDING',
          },
          {
            type: 'FILE_UPLOADED',
          },
        ],
      },
      autoConfig: true,
      debug: false,
    },
  },
  locals: { ...locals },
  modals: {
    UploadDocModal: {},
    ShareholderDetails: {},
    LinkAccountDetails: {},
    GeneralError: {
      excludeModules: ['ProgressBar'],
    },
  },
  theme,
  materialTheme,
  assets: {
    logo: {
      src: 'https://code.ezbob.com/app-ezx/resources/svg/BeBank_logo.svg',
      alt: 'BeBank logo',
    },
    icon: {
      src: 'https://code.ezbob.com/app-ezx/resources/svg/BeBank_icon.svg',
      alt: 'BeBank icon',
    },
  },
  updateUserFields: {
    email: 'applicant.email',
    pw: 'applicant.pw',
  },
  widgetsConfig: {
    loanAgreement: {
      validationRules: 'required',
      customErrorMessage: {
        required: 'READ_DOCUMENT_REQUIRED',
      },
    },
    materialDataGrid: {
      rowsPerPageOptions: [12, 50, 100],
      rowsPerPage: 12,
    },
    onboarding: {
      userSelectOnMultiCases: true,
    },
    contactForm: {
      id: {
        formattingOptions: {
          numericOnly: true,
        },
        inputProps: {
          inputMode: 'numeric',
        },
      },
    },
    applicant: {
      address: {
        firstLineLookup: true,
        validationRules: 'required|address',
        customErrorMessage: {
          required: 'REQUIRED_ADDRESS',
          address: 'ADDRESS',
        },
        policyField: 'loanee.typeOfBusiness',
        lastLineManualEditing: true,
        manualAddress: {
          line1: {
            validationRules: 'required|max:100',
            customErrorMessage: {
              required: 'REQUIRED_LINE1',
            },
          },
          line2: { validationRules: 'max:999' },
          line3: { validationRules: 'max:999' },
          town: {
            validationRules: 'required',
            customErrorMessage: {
              required: 'REQUIRED_TOWN',
            },
          },
          postcode: {
            validationRules: 'required',
            customErrorMessage: {
              required: 'REQUIRED_POSTCODE',
            },
          },
          state: {
            validationRules: 'max:999',
            enabled: false,
            values: {},
          },
          country: {
            validationRules: 'required',
            customErrorMessage: {
              required: 'REQUIRED_COUNTRY',
            },
            enabled: false,
            values: [
              {
                value: 'GB',
              },
            ],
          },
        },
      },
      identifier: {
        validationRules: ['required', 'regex:/^(?!666|000|9\\d{2})\\d{3}-(?!00)\\d{2}-(?!0{4})\\d{4}$/'],
        customErrorMessage: {
          required: 'REQUIRED',
          regex: 'SSNINPUT',
        },
        formattingOptions: {
          useRawValue: false,
          delimiter: '-',
          blocks: [3, 2, 4],
          numericOnly: true,
        },
        maskingOptions: {
          start: 0,
          end: 5,
          maskingSymbol: 'X',
          omitChars: ['-'],
        },
      },
      birthDate: {
        validationRules: `required`,
        customErrorMessage: {
          date: 'DATE',
          required: 'REQUIRED',
        },
        minAge: 18,
        maxAge: 118,
      },
      email: {
        validationRules: 'required|min:3|email',
        customErrorMessage: {
          email: 'VALID_EMAIL',
          required: 'REQUIRED',
          min: 'MIN',
        },
        inputProps: { autoComplete: 'off', type: 'email' },
      },
      password: {
        validationRules: 'required|max:60|regex:/^(?=.*[A-Z])(?=.*\\d)[A-Za-z@$!%*#?&^\\d$]{8,60}$/',
        customErrorMessage: {
          required: 'REQUIRED',
          regex: 'VALID_PASSWORD',
          max: 'MAX_PASSWORD',
        },
        inputProps: { type: 'password' },
      },
      fullName: {
        firstName: {
          validationRules: 'required|min:2|max:100|regex:/^[a-zA-Z -]*$/',
          customErrorMessage: {
            required: 'REQUIRED',
            min: 'MIN',
            max: 'MAX',
            regex: 'INPUT',
          },
        },
        middleName: {
          validationRules: 'max:100|regex:/^[a-zA-Z -]*$/',
          customErrorMessage: {
            max: 'MAX',
            regex: 'INPUT',
          },
        },
        lastName: {
          validationRules: 'required|min:1|max:100|regex:/^[a-zA-Z. -]*$/',
          customErrorMessage: {
            required: 'REQUIRED',
            min: 'MIN',
            max: 'MAX',
            regex: 'INPUT',
          },
        },
      },
      mobile: {
        maxSendCodeAttempts: 3,
        blockUserOnTooManyFailedAttempts: true,
        validationRules: 'required|mobile',
        customErrorMessage: {
          required: 'REQUIRED',
          mobile: 'REQUIRED',
        },
        phone: {
          validationRules: 'required|max:15|phone:GB',
          customErrorMessage: {
            required: 'REQUIRED',
            max: 'MAX',
            phone: 'PHONE_VALID',
          },
        },
        code: {
          validationRules: 'required|min:6|max:6',
          customErrorMessage: {
            required: 'REQUIRED',
            min: 'MIN',
            max: 'MAX',
          },
          formattingOptions: {
            blocks: [6],
            numericOnly: true,
          },
        },
      },
      residentialStatus: {
        yearPickType: 'monthPicker',
      },
      propertyStatus: {
        validationRules: 'required|numeric|min:1',
        customErrorMessage: {
          min: 'REQUIRED',
          required: 'REQUIRED',
        },
        values: propertyStatusList,
      },
      pastAddresses: [
        {
          firstLineLookup: true,
          validationRules: 'required|address',
          customErrorMessage: {
            required: 'REQUIRED_ADDRESS',
            address: 'ADDRESS',
          },
          policyField: 'loanee.typeOfBusiness',
          lastLineManualEditing: true,
          manualAddress: {
            line1: {
              validationRules: 'required|max:100',
              customErrorMessage: {
                required: 'REQUIRED_LINE1',
              },
            },
            line2: { validationRules: 'max:999' },
            line3: { validationRules: 'max:999' },
            town: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_TOWN',
              },
            },
            postcode: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_POSTCODE',
              },
            },
            country: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_COUNTRY',
              },
            },
          },
        },
        {
          firstLineLookup: true,
          validationRules: 'address',
          customErrorMessage: {
            required: 'REQUIRED_ADDRESS',
            address: 'ADDRESS',
          },
          policyField: 'loanee.typeOfBusiness',
          lastLineManualEditing: true,
          manualAddress: {
            line1: {
              validationRules: 'required|max:100',
              customErrorMessage: {
                required: 'REQUIRED_LINE1',
              },
            },
            line2: { validationRules: 'max:999' },
            line3: { validationRules: 'max:999' },
            town: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_TOWN',
              },
            },
            postcode: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_POSTCODE',
              },
            },
            country: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_COUNTRY',
              },
            },
          },
        },
        {
          firstLineLookup: true,
          validationRules: 'address',
          customErrorMessage: {
            required: 'REQUIRED_ADDRESS',
            address: 'ADDRESS',
          },
          policyField: 'loanee.typeOfBusiness',
          lastLineManualEditing: true,
          manualAddress: {
            line1: {
              validationRules: 'required|max:100',
              customErrorMessage: {
                required: 'REQUIRED_LINE1',
              },
            },
            line2: { validationRules: 'max:999' },
            line3: { validationRules: 'max:999' },
            town: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_TOWN',
              },
            },
            postcode: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_POSTCODE',
              },
            },
            country: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_COUNTRY',
              },
            },
          },
        },
      ],
      otherOwnedProperties: [
        {
          firstLineLookup: true,
          validationRules: 'required|address',
          customErrorMessage: {
            required: 'REQUIRED_ADDRESS',
            address: 'ADDRESS',
          },
          policyField: 'loanee.typeOfBusiness',
          lastLineManualEditing: true,
          manualAddress: {
            line1: {
              validationRules: 'required|max:100',
              customErrorMessage: {
                required: 'REQUIRED_LINE1',
              },
            },
            line2: { validationRules: 'max:999' },
            line3: { validationRules: 'max:999' },
            town: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_TOWN',
              },
            },
            postcode: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_POSTCODE',
              },
            },
            country: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_COUNTRY',
              },
            },
          },
        },
        {
          firstLineLookup: true,
          validationRules: 'address',
          customErrorMessage: {
            required: 'REQUIRED_ADDRESS',
            address: 'ADDRESS',
          },
          policyField: 'loanee.typeOfBusiness',
          lastLineManualEditing: true,
          manualAddress: {
            line1: {
              validationRules: 'required|max:100',
              customErrorMessage: {
                required: 'REQUIRED_LINE1',
              },
            },
            line2: { validationRules: 'max:999' },
            line3: { validationRules: 'max:999' },
            town: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_TOWN',
              },
            },
            postcode: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_POSTCODE',
              },
            },
            country: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_COUNTRY',
              },
            },
          },
        },
        {
          firstLineLookup: true,
          validationRules: 'address',
          customErrorMessage: {
            required: 'REQUIRED_ADDRESS',
            address: 'ADDRESS',
          },
          policyField: 'loanee.typeOfBusiness',
          lastLineManualEditing: true,
          manualAddress: {
            line1: {
              validationRules: 'required|max:100',
              customErrorMessage: {
                required: 'REQUIRED_LINE1',
              },
            },
            line2: { validationRules: 'max:999' },
            line3: { validationRules: 'max:999' },
            town: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_TOWN',
              },
            },
            postcode: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_POSTCODE',
              },
            },
            country: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_COUNTRY',
              },
            },
          },
        },
      ],
      idVerification: {
        desktop: {
          checkStatusInterval: { seconds: 5 },
          phone: {
            validationRules: 'required|max:15|phone:GB',
            customErrorMessage: {
              regex: 'PHONE_VALID',
              required: 'REQUIRED',
              max: 'MAX',
              phone: 'PHONE_VALID',
            },
          },
        },
        mobile: {
          requestPhotos: ['front', 'selfie', 'back'],
          disableWelcomeScreen: false,
          maxFileSize: 5242880,
          allowFileExtensions: ['png', 'jpg', 'tif', 'tiff', 'jpeg'],
        },
      },
      gender: {
        validationRules: 'required',
        values: [
          {
            value: 'm',
            icon: 'https://code.ezbob.com/app-ezx/greenlend/images/male_icon.svg',
          },
          {
            value: 'f',
            icon: 'https://code.ezbob.com/app-ezx/greenlend/images/female_icon.svg',
          },
        ],
      },
    },
    contributors: [
      {
        fullName: {
          firstName: {
            validationRules: 'required|min:2|max:100|regex:/^[a-zA-Z -]*$/',
            customErrorMessage: {
              required: 'REQUIRED',
              min: 'MIN',
              max: 'MAX',
              regex: 'INPUT',
            },
          },
          lastName: {
            validationRules: 'required|min:1|max:100|regex:/^[a-zA-Z. -]*$/',
            customErrorMessage: {
              required: 'REQUIRED',
              min: 'MIN',
              max: 'MAX',
              regex: 'INPUT',
            },
          },
        },
        identifier: {
          validationRules: 'required',
          customErrorMessage: {
            required: 'REQUIRED',
          },
        },
        email: {
          validationRules: 'required|email',
          customErrorMessage: {
            email: 'VALID_EMAIL',
            required: 'REQUIRED',
          },
          inputProps: {
            autoComplete: 'off',
            type: 'email',
          },
        },
        phoneNumber: {
          validationRules: 'required|max:15',
          customErrorMessage: {
            required: 'REQUIRED',
            max: 'MAX',
          },
        },
      },
    ],
    loanee: {
      typeOfBusiness: {
        validationRules: 'required',
        values: typeOfBusiness,
        customErrorMessage: {
          required: 'REQUIRED',
        },
      },
      name: {
        validationRules: 'required|min:2|max:255',
        customErrorMessage: {
          required: 'VALID_COMPANY',
          min: 'MIN',
          max: 'MAX',
        },
      },
      identifier: {
        validationRules: 'required',
        customErrorMessage: {
          required: 'VALID_COMPANY',
        },
      },
      companyType: {
        validationRules: 'required|includes:ltd,limited|min:2|max:255',
        customErrorMessage: {
          required: 'VALID_COMPANY',
          min: 'MIN',
          max: 'MAX',
          includes: 'VALID_COMPANY_TYPE',
        },
      },
      companyNameNumber: {
        enableCompanyType: false,
        lastLineManualEditing: true,
        validationRules: 'required|min:1',
        customErrorMessage: {
          required: 'VALID_COMPANY',
          min: 'MIN',
          regex: 'INPUT',
        },
        manualNameNumber: {
          name: {
            validationRules: 'required|min:2|max:255',
            customErrorMessage: {
              required: 'REQUIRED',
              min: 'MIN',
              max: 'MAX',
            },
          },
          identifier: {
            validationRules: 'required|alpha_num|min:8|max:8',
            customErrorMessage: {
              required: 'REQUIRED',
              alpha_num: 'INPUT',
              min: 'MIN',
              max: 'MAX',
            },
          },
        },
      },
      businessAddressSelector: {
        defaultValue: false,
      },
      businessAddress: {
        LIMITED_COMPANY: {
          firstLineLookup: true,
          validationRules: 'required|address',
          customErrorMessage: {
            required: 'REQUIRED_ADDRESS',
            address: 'ADDRESS',
          },
          lastLineManualEditing: true,
          policyField: 'loanee.typeOfBusiness',
          checkAlreadyMatch: true,
          manualAddress: {
            line1: {
              validationRules: 'required|max:100',
              customErrorMessage: {
                required: 'REQUIRED_LINE1',
              },
            },
            line2: { validationRules: 'max:999' },
            line3: { validationRules: 'max:999' },
            town: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_TOWN',
              },
            },
            postcode: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_POSTCODE',
              },
            },
            country: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_COUNTRY',
              },
            },
          },
        },
        SOLE_TRADER: {
          firstLineLookup: true,
          validationRules: 'required|address',
          customErrorMessage: {
            required: 'REQUIRED_ADDRESS',
            address: 'ADDRESS',
          },
          lastLineManualEditing: true,
          policyField: 'loanee.typeOfBusiness',
          checkAlreadyMatch: true,
          manualAddress: {
            line1: {
              validationRules: 'required|max:100',
              customErrorMessage: {
                required: 'REQUIRED_LINE1',
              },
            },
            line2: { validationRules: 'max:999' },
            line3: { validationRules: 'max:999' },
            town: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_TOWN',
              },
            },
            postcode: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_POSTCODE',
              },
            },
            country: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_COUNTRY',
              },
            },
          },
        },
      },
      annualRevenue: {
        LIMITED_COMPANY: {
          validationRules: 'required|numeric|min:15000|max:2000000',

          customErrorMessage: {
            required: 'REQUIRED',
            numeric: 'NUMERIC',
            min: 'MIN_AMOUNT',
            max: 'MAX_AMOUNT',
          },
          formattingOptions: { ...currencyFormattingOptions, numeralDecimalScale: 0 },
          inputProps: { type: 'currency' },
        },
        SOLE_TRADER: {
          validationRules: 'required|numeric|max:999999999',
          customErrorMessage: {
            required: 'REQUIRED',
            numeric: 'NUMERIC',
            max: 'MAX_AMOUNT',
          },
          formattingOptions: { ...currencyFormattingOptions, numeralDecimalScale: 0 },
          inputProps: { type: 'currency' },
        },
      },
      annualNetProfitBeforeTax: {
        LIMITED_COMPANY: {
          validationRules: 'required|numeric|min:1',
          customErrorMessage: {
            required: 'REQUIRED',
            numeric: 'NUMERIC',
            min: 'MIN_AMOUNT',
            max: 'MAX_AMOUNT',
          },
          inputProps: { type: 'currency' },
          formattingOptions: { ...currencyFormattingOptions, numeralDecimalScale: 0 },
        },
        SOLE_TRADER: {
          validationRules: 'required|numeric',
          customErrorMessage: {
            required: 'REQUIRED',
            numeric: 'NUMERIC',
            min: 'MIN_AMOUNT',
            max: 'MAX_AMOUNT',
          },
          inputProps: { type: 'currency' },
          formattingOptions: { ...currencyFormattingOptions, numeralDecimalScale: 0 },
        },
      },
      monthlyDebtRepayments: {
        LIMITED_COMPANY: {
          validationRules: 'numeric',
          customErrorMessage: {
            numeric: 'NUMERIC',
          },
          inputProps: { type: 'currency' },
          formattingOptions: { ...currencyFormattingOptions, numeralDecimalScale: 0 },
        },
        SOLE_TRADER: {
          validationRules: 'required|numeric|max:999999999',
          customErrorMessage: {
            required: 'REQUIRED',
            numeric: 'NUMERIC',
            max: 'MAX_AMOUNT',
          },
          inputProps: { type: 'currency' },
          formattingOptions: { ...currencyFormattingOptions, numeralDecimalScale: 0 },
        },
      },
      minAnnualDirectorDividends: {
        validationRules: 'numeric',
        customErrorMessage: {
          numeric: 'NUMERIC',
          max: 'MAX_AMOUNT',
        },
        inputProps: { type: 'currency' },
        formattingOptions: { ...currencyFormattingOptions, numeralDecimalScale: 0 },
      },
      annualDrawings: {
        validationRules: 'required|numeric|max:999999999',
        customErrorMessage: {
          required: 'REQUIRED',
          numeric: 'NUMERIC',
          max: 'MAX_AMOUNT',
        },
        inputProps: { type: 'currency' },
        formattingOptions: { ...currencyFormattingOptions, numeralDecimalScale: 0 },
      },
      tradingActivity: {
        validationRules: 'required|string',
        customErrorMessage: {
          required: 'REQUIRED',
          string: 'SELECT_FROM_LIST',
        },
        values: tradingActivityList,
      },
    },

    loanRequest: {
      monthlyRepaymentsPosition: 'top',
      showTermsSlider: true,
      showMonthlyPayment: true,
      useServerCalculation: false,
      showControls: true,
      loanPurpose: {
        LIMITED_COMPANY: {
          validationRules: 'required',
          customErrorMessage: {
            required: 'REQUIRED',
          },
          values: loanPurposeList_LIMITED_COMPANY,
        },
        SOLE_TRADER: {
          validationRules: 'required',
          customErrorMessage: {
            required: 'REQUIRED',
          },
          values: loanPurposeList_SOLE_TRADER,
        },
      },
      otherLoanPurpose: {
        validationRules: 'required',
        customErrorMessage: {
          required: 'REQUIRED',
        },
      },
      amount: {
        LIMITED_COMPANY: {
          defaultValue: 80000,
          min: 10000,
          max: 150000,
          step: 500,
          valueFieldModifiers: false,
          sliderModifiers: true,
          inputFormattingOptions: { ...currencyFormattingOptions },
          formattingOptions: {
            ...currencyFormattingOptions,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          },
        },
        SOLE_TRADER: {
          defaultValue: 87500,
          min: 25500,
          max: 150000,
          step: 500,
          valueFieldModifiers: false,
          sliderModifiers: true,
          inputFormattingOptions: { ...currencyFormattingOptions },
          formattingOptions: {
            ...currencyFormattingOptions,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          },
        },
      },
      term: {
        LIMITED_COMPANY: {
          defaultValue: 24,
          min: 12,
          max: 60,
          step: 6,
          valueFieldModifiers: false,
          sliderModifiers: true,
        },
        SOLE_TRADER: {
          defaultValue: 24,
          min: 12,
          max: 60,
          step: 6,
          valueFieldModifiers: false,
          sliderModifiers: true,
        },
      },
    },
    login: {
      enableOTP: true,
      showClosedApplications: true,
      username: {
        validationRules: 'required|email',
        customErrorMessage: {
          email: 'VALID_EMAIL',
          required: 'REQUIRED',
        },
        inputProps: { autoComplete: 'off' },
      },
      password: {
        validationRules: 'required|max:60|regex:/^(?=.*[A-Z])(?=.*\\d)[A-Za-z@$!%*#?&^\\d$]{8,60}$/',
        customErrorMessage: {
          required: 'REQUIRED',
          regex: 'VALID_PASSWORD',
          max: 'MAX_PASSWORD',
        },
        inputProps: { type: 'password' },
      },
      mobile: {
        validationRules: 'required|mobile',
        customErrorMessage: {
          required: 'REQUIRED',
          mobile: 'REQUIRED',
        },
        phone: {
          validationRules: 'required|max:15|phone:GB',
          customErrorMessage: {
            required: 'REQUIRED',
            max: 'MAX',
            phone: 'PHONE_VALID',
          },
        },
        verify: {
          validationRules: 'max:6|required|regex:/^\\d+$/',
          customErrorMessage: {
            regex: 'INPUT',
            required: 'REQUIRED',
            max: 'MAX',
          },
        },
      },
    },

    forgotPassword: {
      email: {
        validationRules: 'required|email',
        customErrorMessage: {
          email: 'VALID_EMAIL',
          required: 'REQUIRED',
        },
        inputProps: { autoComplete: 'off', type: 'email' },
      },
    },
    createPassword: {
      password: {
        validationRules: 'required|max:60|regex:/^(?=.*[A-Z])(?=.*\\d)[A-Za-z@$!%*#?&^\\d$]{8,60}$/',
        customErrorMessage: {
          required: 'REQUIRED',
          regex: 'VALID_PASSWORD',
          max: 'MAX_PASSWORD',
        },
        inputProps: { type: 'password' },
      },
    },

    officers: {
      showNextButton: false,
      fraudIncludeThisIsMeShareholders: true,
      fraudIncludeNotActiveShareholders: true,
      enableWasEditSkipped: false,
      type: 'ALL',
      includeCompanies: false,
      personDetails: {
        address: {
          firstLineLookup: true,
          validationRules: 'required|address',
          customErrorMessage: {
            required: 'REQUIRED_ADDRESS',
            address: 'ADDRESS',
          },
          policyField: 'loanee.typeOfBusiness',
          lastLineManualEditing: true,
          manualAddress: {
            line1: {
              validationRules: 'required|max:100',
              customErrorMessage: {
                required: 'REQUIRED_LINE1',
              },
            },
            line2: { validationRules: 'max:999' },
            line3: { validationRules: 'max:999' },
            town: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_TOWN',
              },
            },
            postcode: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_POSTCODE',
              },
            },
            country: {
              validationRules: 'required',
              customErrorMessage: {
                required: 'REQUIRED_COUNTRY',
              },
            },
          },
        },
        identifier: {
          validationRules: ['required', 'regex:/^(?!666|000|9\\d{2})\\d{3}-(?!00)\\d{2}-(?!0{4})\\d{4}$/'],
          customErrorMessage: {
            required: 'REQUIRED',
            regex: 'SSNINPUT',
          },
          formattingOptions: {
            useRawValue: false,
            delimiter: '-',
            blocks: [3, 2, 4],
            numericOnly: true,
          },
          maskingOptions: {
            start: 0,
            end: 5,
            maskingSymbol: 'X',
            omitChars: ['-'],
          },
        },
        birthDate: {
          validationRules: `required`,
          customErrorMessage: {
            date: 'DATE',
            required: 'REQUIRED',
          },
          minAge: 18,
          maxAge: 118,
        },
        email: {
          validationRules: 'required|email',
          customErrorMessage: {
            email: 'VALID_EMAIL',
            required: 'REQUIRED',
          },
          inputProps: { autoComplete: 'off', type: 'email' },
        },
        fullName: {
          firstName: {
            validationRules: "required|min:2|max:100|regex:/^[a-zA-Z '-]*$/",
            customErrorMessage: {
              required: 'REQUIRED',
              min: 'MIN',
              max: 'MAX',
              regex: 'INPUT',
            },
          },
          middleName: {
            validationRules: "max:100|regex:/^[a-zA-Z '-]*$/",
            customErrorMessage: {
              max: 'MAX',
              regex: 'INPUT',
            },
          },
          lastName: {
            validationRules: "required|min:1|max:100|regex:/^[a-zA-Z '-]*$/",
            customErrorMessage: {
              required: 'REQUIRED',
              min: 'MIN',
              max: 'MAX',
              regex: 'INPUT',
            },
          },
        },
      },
    },
    personsSignificantControl: {
      type: 'ALL',
      includeCompanies: false,
    },
    meta: {
      consents: {
        privacyNote: {
          validationRules: 'accepted',
          customErrorMessage: {
            accepted: 'REQUIRED',
          },
        },
        businessLoanAgreement: {
          validationRules: 'accepted',
          customErrorMessage: {
            accepted: 'REQUIRED',
          },
        },
        termsAndConditions: {
          validationRules: 'accepted',
          customErrorMessage: {
            accepted: 'REQUIRED',
          },
        },
        authorizedDirector: {
          validationRules: 'accepted',
          customErrorMessage: {
            accepted: 'REQUIRED',
          },
        },
        personalGuarantee: {
          validationRules: 'accepted',
          customErrorMessage: {
            accepted: 'REQUIRED',
          },
        },
      },
      communicationOptions: {},
      keepInformed: {},
    },
    vatStatement: {
      upload: {
        maxFiles: 30,
        maxSize: 52428800, //50 MB
        fileExtensions: [{ value: 'pdf', active: true }],
        type: 'VAT',
      },
    },
    accountScoreStatement: {
      upload: {
        maxFiles: 30,
        maxSize: 52428800, // 50 MB
        fileExtensions: [
          { value: 'pdf', active: true },
          { value: 'doc', active: true },
          { value: 'docx', active: true },
          { value: 'odt', active: true },
          { value: 'rtf', active: true },
          { value: 'ppt', active: true },
          { value: 'pptx', active: true },
          { value: 'odp', active: true },
          { value: 'xls', active: true },
          { value: 'xlsx', active: true },
          { value: 'ods', active: true },
          { value: 'txt', active: true },
          { value: 'csv', active: true },
          { value: 'xml', active: true },
          { value: 'xhtml', active: true },
          { value: 'mht', active: true },
          { value: 'msg', active: true },
          { value: 'eml', active: true },
          { value: 'bpm', active: true },
          { value: 'jpg', active: true },
          { value: 'jpeg', active: true },
          { value: 'png', active: true },
        ],
        type: 'BANK',
      },
    },
    bankAccountStatement: {
      linkAccountDetails: {
        displayIcons: ['HSBC', 'Barclays', 'Lloyds', 'RBS', 'Santander', 'NatWest', 'Dag', 'Halifax', 'NationWide'],
      },
      upload: {
        maxFiles: 30,
        maxSize: 52428800, // 50 MB
        fileExtensions: [
          { value: 'pdf', active: true },
          { value: 'doc', active: true },
          { value: 'docx', active: true },
          { value: 'odt', active: true },
          { value: 'rtf', active: true },
          { value: 'ppt', active: true },
          { value: 'pptx', active: true },
          { value: 'odp', active: true },
          { value: 'xls', active: true },
          { value: 'xlsx', active: true },
          { value: 'ods', active: true },
          { value: 'txt', active: true },
          { value: 'csv', active: true },
          { value: 'xml', active: true },
          { value: 'xhtml', active: true },
          { value: 'mht', active: true },
          { value: 'msg', active: true },
          { value: 'eml', active: true },
          { value: 'bpm', active: true },
          { value: 'jpg', active: true },
          { value: 'jpeg', active: true },
          { value: 'png', active: true },
        ],
        type: 'BANK',
      },
    },
    financialAccountsStatement: {
      linkAccountDetails: {
        displayIcons: [
          'sage 50',
          'sage 200',
          'sage 300',
          'xero partner',
          'dynamics-gp',
          'navision',
          'quickbooks',
          'quickbooks-online',
          'free agent',
        ],
      },
      upload: {
        maxFiles: 30,
        maxSize: 52428800, // 50 MB
        fileExtensions: [
          { value: 'pdf', active: true },
          { value: 'doc', active: true },
          { value: 'docx', active: true },
          { value: 'odt', active: true },
          { value: 'rtf', active: true },
          { value: 'ppt', active: true },
          { value: 'pptx', active: true },
          { value: 'odp', active: true },
          { value: 'xls', active: true },
          { value: 'xlsx', active: true },
          { value: 'ods', active: true },
          { value: 'txt', active: true },
          { value: 'csv', active: true },
          { value: 'xml', active: true },
          { value: 'xhtml', active: true },
          { value: 'mht', active: true },
          { value: 'msg', active: true },
          { value: 'eml', active: true },
          { value: 'bpm', active: true },
          { value: 'jpg', active: true },
          { value: 'jpeg', active: true },
          { value: 'png', active: true },
        ],
        type: 'OTHER',
      },
    },
    eCommerce: {
      paypal: {
        type: 'paypal',
      },
      ebay: {
        type: 'ebay',
      },
      amazon: {
        type: 'amazon',
      },
    },
    linkAccount: {
      paypal: {
        type: 'instructionsAndTab',
        contentType: 'paypal',
        linkedService: 'paypal',
        accountType: 'paypal',
        serviceName: 'generate-login-url',
      },
      ebay: {
        type: 'instructionsAndTab',
        contentType: 'ebay',
        linkedService: 'ebay',
        accountType: 'ebay',
        serviceName: 'generate-login-url',
      },
      amazon: {
        type: 'amazon',
        contentType: 'amazon',
        linkedService: 'amazon',
        accountType: 'amazon',
        serviceName: 'link',
        sellerId: {
          validationRules: 'required',
          customErrorMessage: {
            required: 'REQUIRED',
          },
        },
        marketplaceId: {
          validationRules: 'required',
          customErrorMessage: {
            required: 'REQUIRED',
          },
        },
        authorizationToken: {
          validationRules: 'required',
          customErrorMessage: {
            required: 'REQUIRED',
          },
        },
      },
    },
    decision: {
      decisionPolicy: 'legacy',
      minimumRequirements: [
        { widgetName: 'vatStatement.upload', minimum: 0 },
        { widgetName: 'bankAccountStatement.linkAccountDetails', minimum: 0 },
        { widgetName: 'bankAccountStatement.upload', minimum: 0 },
        { widgetName: 'financialAccountsStatement.linkAccountDetails', minimum: 0 },
        { widgetName: 'financialAccountsStatement.upload', minimum: 0 },
        { widgetName: 'accountScoreStatement.upload', minimum: 0 },
        { widgetName: 'accountScoreStatement.linkAccountDetails', minimum: 0 },
        { widgetName: 'eCommerce.paypal', minimum: 0 },
        { widgetName: 'eCommerce.ebay', minimum: 0 },
        { widgetName: 'eCommerce.amazon', minimum: 0 },
      ],
      minimumMarketPlaceItems: 1,
      waitTime: { seconds: 10 }, // Use moment docs for formatting -  https://momentjs.com/docs/#/durations/
    },
    popupLoader: {
      type: 'ball-pulse',
    },
    customerLogin: {
      showClosedApplications: true,
      allowNewApplication: true,
      allowCancelApplication: true,
      allowIncorrectInformation: false,
      summaryFields: [
        'loanee.typeOfBusiness',
        'loanee.name',
        'loanRequest.loanPurpose',
        'loanRequest.amount',
        'loanRequest.term',
        'applicant.fullName.firstName',
        'applicant.fullName.middleName',
        'applicant.fullName.lastName',
        'applicant.birthDate',
        'applicant.address',
        'applicant.pastAddresses',
      ],
      username: {
        validationRules: 'required|email',
        customErrorMessage: {
          email: 'VALID_EMAIL',
          required: 'REQUIRED',
        },
        inputProps: {
          autoComplete: 'false',
        },
      },
      phone: {
        validationRules: 'required|max:15|phone:GB',
        customErrorMessage: {
          required: 'REQUIRED',
          max: 'MAX',
          phone: 'PHONE_VALID',
        },
      },
      code: {
        validationRules: 'required|min:6|max:6',
        customErrorMessage: {
          required: 'REQUIRED',
          min: 'MIN',
          max: 'MAX',
        },
        formattingOptions: {
          blocks: [6],
          numericOnly: true,
        },
      },
      loanRequest: {
        amount: {
          formattingOptions: {
            ...currencyFormattingOptions,
          },
          type: 'number',
        },
      },
    },
    applicationSummary: {
      loanAmount: {
        formattingOptions: {
          ...currencyFormattingOptions,
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        },
      },
    },
    sliders: {
      offerAmount: {
        formattingOptions: {
          ...currencyFormattingOptions,
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        },
      },
      monthlyPayment: {
        formattingOptions: {
          ...currencyFormattingOptions,
        },
      },
    },
    congratulations: {
      fee: {
        formattingOptions: {
          ...currencyFormattingOptions,
        },
      },
    },
    otp: {
      isLoginOTP: true,
      showCountdown: false,
      inputType: 'text_field',
      otpInputLength: 6,
      channel: {
        defaultValue: 'SMS',
        values: [{ value: 'SMS' }],
      },
      code: {
        validationRules: 'required|min:6',
        customErrorMessage: {
          required: 'REQUIRED',
          min: 'MIN',
        },
        resendTimeoutDuration: {
          seconds: 30,
        },
        inputProps: {
          type: 'number',
          autocomplete: 'one-time-code',
        },
      },
      screenWrapper: {
        backgroundImage: {
          desktop: '',
          mobile: '',
        },
      },
      inputFields: {
        id: {
          formattingOptions: {
            numericOnly: true,
          },
          inputProps: {
            inputMode: 'numeric',
          },
        },
      },
    },
  },
  languages: {
    defaultLanguage: 'en-GB',
    fallbackLanguage: 'en-GB',
    languageList: {
      'en-GB': { translation: enLanguage },
    },
  },
  environments: {
    appHost: 'app.ezbob.com',
  },
  routing: {
    logoutUrl: `/customer/login`,
  },
};
